module.exports = __webpack_public_path__ + "static/media/kbms-logo.30066572.png";